const PropTypes = require('prop-types');
const React = require('react');
const ProductSearchForm = require('../../product_search_form/product_search_form.jsx');
const { Tracker } = require('@reverbdotcom/discovery-ui');


class ProductSuggestion extends React.Component {
  constructor() {
    super();

    this.handleProductSelected = this.handleProductSelected.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {
      results: [],
      inputValue: '',
    };
  }

  handleProductSelected(product) {
    this.props.onProductSelected(product);

    Tracker.trackInteraction({
      name: 'ProductSuggestion',
      type: 'listing',
      id: product.id,
      context: { source: this.props.analyticsSource },
    });

    // hide the search results
    this.setState({
      results: [],
      inputValue: '',
    });
  }

  handleChange(e) {
    this.setState({ inputValue: e.target.value });
  }

  render() {
    return (
      <div className="message-attach-listings">
        <ProductSearchForm
          productSelected={this.handleProductSelected}
          currentListingIds={this.props.currentListingIds}
          results={this.state.results}
          inputValue={this.state.inputValue}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

ProductSuggestion.propTypes = {
  currentListingIds: PropTypes.arrayOf(PropTypes.number),
  analyticsSource: PropTypes.string.isRequired,
  onProductSelected: PropTypes.func.isRequired,
};

module.exports = ProductSuggestion;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/messages/product_suggestion.jsx